import { get as idbGet, set as idbSet, del as idbDel, clear as idbClear, createStore } from 'idb-keyval';
import type { IdbStore } from './types';

const DB_NAME = 'himotchi-db';
const STORE_NAME = 'himotchi-store';

class IdbStoreImpl implements IdbStore {
  private store = createStore(DB_NAME, STORE_NAME);

  async get<T>(key: string): Promise<T | null> {
    const v = await idbGet<T>(key, this.store);
    return v ?? null;
  }

  async set<T>(key: string, value: T): Promise<void> {
    await idbSet(key, value, this.store);
  }

  async delete(key: string): Promise<void> {
    await idbDel(key, this.store);
  }

  async clear(): Promise<void> {
    await idbClear(this.store);
  }
}

let _instance: IdbStore | null = null;

export function getIdbStore(): IdbStore {
  if (!_instance) _instance = new IdbStoreImpl();
  return _instance;
}

export function setIdbStoreForTests(impl: IdbStore): void {
  _instance = impl;
}

export function resetIdbStoreForTests(): void {
  _instance = null;
}
